export default "__VITE_ASSET__BzCZhr2J__"